import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { Subject } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { SelectFolderConfig } from '../select-folder/select-folder.component';
import { StorageItem } from '@uploadcam/common';

export interface SelectFolderDialogInput {
  title: string;
  config: SelectFolderConfig;
}

export type SelectFolderDialogResult = StorageItem | undefined;

@Component({
  selector: 'app-select-folder-dialog',
  templateUrl: './select-folder-dialog.component.html',
  styleUrl: './select-folder-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class SelectFolderDialogComponent {
  protected readonly createFolder$ = new Subject<void>();
  protected showCreateFolder = false;
  protected selected?: StorageItem;

  constructor(
    @Inject(MAT_DIALOG_DATA) protected readonly data: SelectFolderDialogInput,
    private readonly dialogRef: MatDialogRef<SelectFolderDialogComponent, SelectFolderDialogResult>,
  ) {}

  protected folderSelected(folder?: StorageItem): void {
    this.selected = folder;
  }

  protected select(): void {
    this.dialogRef.close(this.selected);
  }
}
